/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  /**
   *
   */
  scrollTo.$inject = [
    'anchorNavService', 
    'pageMetaService',
    '$timeout',
    '$window',
  ];

  export function scrollTo(
    anchorNavService : IAnchorNavService, 
    pageMetaService: navigation.IPageMetaService,
    $timeout : ng.ITimeoutService,
    $window: ng.IWindowService
    ): ng.IDirective {
    return {
      restrict: 'A',
      scope: {
        scrollTo: '@',
      },
      link: function (scope : any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        //from ng-href
        var attrName = "href";
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            Object.prototype.toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href'; 
          propName = null;
        }

        attr.$observe('scrollTo', function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }
          attr.$set(name, pageMetaService.getPageMeta('hlPrefix') + pageMetaService.getPageMeta().RouteData.BasePageUrl + value);
        });


        element.bind('click', ($event : JQueryEventObject) => {
          $event.preventDefault();
          anchorNavService.scrollTo(scope.scrollTo);
        });   

      }
    }
  }
}